import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngxui-sidenav-menu',
  templateUrl: './sidenav-menu.component.html',
  styleUrls: ['./sidenav-menu.component.scss']
})
export class SidenavMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
